var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11787 10.4036L12.0022 6.52089L15.8881 10.4068L18.1469 8.14633L12.0022 2L5.85742 8.14475L8.11787 10.4036Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0006L4.25887 9.74011L6.51931 12.0006L4.25887 14.2594L2 12.0006Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11787 13.5961L12.0022 17.4804L15.8881 13.5945L18.1485 15.8518L12.0038 21.9981L5.85742 15.8565L8.11787 13.5961Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4805 12.0006L19.7393 9.74011L21.9998 11.999L19.7393 14.261L17.4805 12.0006Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.294 11.9991L12.002 9.70544L10.3071 11.4004L10.1112 11.5947L9.70996 11.9959L12.002 14.2864L14.294 12.0006V11.9991Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.54d4fffc214ab34820ca8d54ae7bb1e1.svg";
export { ForwardRef as ReactComponent };